<template>
  <section
    class="naj-box"
    :class="{ 'margin-bottom': !noBottomMargin }"
  >
    <header
      v-if="!noHeader"
      class="naj-box-header"
      :class="{ pointer: !disableCollapsing }"
      @click.self="headerClickHandler"
    >
      <div @click.self="headerClickHandler">
        <div class="header-slot">
          <slot name="header" />
        </div>
        <v-icon
          v-if="computedHeaderIcon"
          :class="[
            'header-icon',
            {
              'close-modal-button': insideModal,
            },
          ]"
          @click.self="headerClickHandler"
        >
          {{ computedHeaderIcon }}
        </v-icon>
      </div>
      <span class="naj-box-header-title">{{ title }}</span>
    </header>

    <div
      v-show="!isCollapsed || disableCollapsing"
      class="naj-box-contnet"
      :class="{ 'no-gutters': noGutters,'no-h-gutters':noHGutters,'no-v-gutters' :noVGutters}"
    >
      <slot />
    </div>

    <footer
      v-if="hasFooter"
      v-show="!isCollapsed || disableCollapsing"
      class="naj-box-footer"
    >
      <slot name="footer" />
    </footer>
    <span
      v-if="errorMessage"
      class="v-messages error--text error-message"
    >{{ errorMessage }}</span>
  </section>
</template>

<script>
export default {
  name: 'NajBox',
  inject: {
    $validator: { default: {} },
    formContext: { default: {} },
  },
  props: {
    noHeader: { type: Boolean },
    title: { type: String },
    errorMessage: {
      type: String,
      required: false,
    },
    headerIcon: { type: String },
    collapsed: { type: Boolean },
    noGutters: {
      type: Boolean,
      default: false,
    },
    noHGutters: {
      type: Boolean,
      default: false,
    },
    noVGutters: {
      type: Boolean,
      default: false,
    },
    hasFooter: {
      type: Boolean,
      default: false,
    },
    noBottomMargin: { type: Boolean },
    insideModal: { type: Boolean },
    disableCollapsing: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return { isCollapsed: false };
  },
  computed: {
    computedHeaderIcon() {
      return !this.disableCollapsing
        ? this.isCollapsed
          ? 'mdi-chevron-down'
          : 'mdi-chevron-up'
        : this.headerIcon;
    },
  },
  watch: {
    formContext: {
      deep: true,
      handler(form) {
        if (form.isSubmitted && this.isRequired) {
          this.$validator.validateScopes()
            .then((valid) => {
              if (!valid) {
                this.isCollapsed = false;
              }
            });
        }
      },
    },
    collapsed(collapsed) {
      this.isCollapsed = collapsed;
    },
  },
  mounted() {
    this.isCollapsed = this.collapsed;
  },
  methods: {
    headerClickHandler() {
      if (!this.disableCollapsing) {
        this.isCollapsed = !this.isCollapsed;
      } else {
        this.$emit('iconClick');
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.naj-box {
  width: 100%;
  height: 100%;
  background-color: #fff;
  box-shadow: 5px 0 12px 0 rgba(228, 230, 238, 0.6);
  //border-top: 2px solid var(--app-lighter-primary-color);
  border: 1px solid #dbdbdb;

  .naj-box {
    border-top: initial;
    box-shadow: none;
  }
  .header-slot {
    display: inline-block;
  }
  .header-icon {
    //margin-right: 15px;
    //color: var(--app-lighter-primary-color);
    margin-left: 10px;
    color: #14353c;
  }

  &.margin-bottom {
    margin-bottom: 25px;
  }

  ::v-deep .naj-box-header {
    position: relative;
    background-color: #fff;
    border-bottom: 2px solid #f4f5f8;
    padding: 10px 20px;
    display: flex;
    align-items: center;
    color: #464545;
    font-size: 16px;
    line-height: 1.5;
    // justify-content: space-between;
    font-weight: 700;
    background-color: var(--app-light-secondary-color);
    &.pointer {
      cursor: pointer;
    }

    .naj-box-header-title {
      font-size: 22px;
    }
  }

  .naj-box-footer {
    min-height: 30px;
    border-top: 2px solid #f4f5f8;
    padding: 20px;
    display: flex;
    align-items: center;
    color: #d8d8d8;
    font-size: 16px;
    justify-content: space-between;
    background-color: rgba(216, 216, 216, 0.1);
  }

  .naj-box-contnet {
    padding: 20px;
    border: 1px solid #dbdbdb;
    border-top: none;

    &.no-gutters {
      padding: 0;
    }

    &.no-h-gutters {
      padding-top: 0px;
      padding-bottom: 0px;
    }

    &.no-v-gutters {
      padding-right: 0px;
      padding-left: 0px;
    }
  }
}
</style>
